import { translate } from "app/language/service"
import { IOperator } from "operator/model"
import { searchOperatorsByName } from "operator/tools/search"
import React from "react"
import { EntitiesSelect } from "ui/components/EntitiesSelect"

interface IOperatorSelectProps {
  id?: string
  defaultOperators?: IOperator[]
  onChange: (operators: IOperator[]) => any
}

export const OperatorSelect = React.memo(
  ({ id, defaultOperators, onChange }: IOperatorSelectProps): JSX.Element => (
    <EntitiesSelect
      defaultSelectedEntities={defaultOperators}
      id={id || "operator-select"}
      inputLabel={translate("operators.title")}
      inputPlaceholder={translate("label.search.name")}
      getOptionLabel={(operator: any) => operator.publisher_name || "-"}
      onChange={operators => onChange(operators as IOperator[])}
      searchEntities={filter => searchOperatorsByName(filter)}
    />
  )
)
